import { render, staticRenderFns } from "./ShoppingArtikel.vue?vue&type=template&id=471be490"
import script from "./ShoppingArtikel.vue?vue&type=script&lang=ts"
export * from "./ShoppingArtikel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports